import { createSlice, createAction } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import httpClient from 'lib/request/httpClient';

export const FILE_UPLOADS = {
	UPLOAD_START: 'SFDC/FILE_UPLOADS/UPLOAD_START',
	UPLOAD_SUCCESS: 'SFDC/FILE_UPLOADS/UPLOAD_SUCCESS',
	UPLOAD_FAILURE: 'SFDC/FILE_UPLOADS/UPLOAD_FAILURE',
	UPLOAD_PROGRESS: 'SFDC/FILE_UPLOADS/UPLOAD_PROGRESS',
	REMOVE_FILE: 'SFDC/FILE_UPLOADS/REMOVE_FILE',
	SET_UPLOAD_URL: 'SFDC/FILE_UPLOADS/SET_UPLOAD_URL'
};

export const initialState = {
	uploadProgress: {},
	uploadUrls: {}
};

const fileUploadSlice = createSlice({
	name: 'fileUpload',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(FILE_UPLOADS.UPLOAD_PROGRESS, (state, action) => ({
				...state,
				uploadProgress: {
					...state.uploadProgress,
					[action.payload.fileName]: action.payload.uploadProgress
				}
			}))
			.addCase(FILE_UPLOADS.SET_UPLOAD_URL, (state, action) => ({
				...state,
				uploadUrls: {
					...state.uploadUrls,
					[action.payload.fileName]: action.payload.uploadUrl
				},
				documentKeys: {
					...state.documentKeys,
					[action.payload.fileName]: action.payload.key
				}
			}))
			.addCase(FILE_UPLOADS.REMOVE_FILE, (state, action) => ({
				uploadProgress: {
					...omit(state.uploadProgress, action.payload)
				},
				uploadUrls: {
					...omit(state.uploadUrls, action.payload)
				},
				documentKeys: {
					...omit(state.documentKeys, action.payload)
				}
			}));
	}
});

export const uploadStart = createAction(FILE_UPLOADS.UPLOAD_START);
export const uploadProgress = createAction(FILE_UPLOADS.UPLOAD_PROGRESS);
export const uploadSuccess = createAction(FILE_UPLOADS.UPLOAD_SUCCESS);
export const uploadFailure = createAction(FILE_UPLOADS.UPLOAD_FAILURE);
export const removeFile = createAction(FILE_UPLOADS.REMOVE_FILE);
export const setUploadUrl = createAction(FILE_UPLOADS.SET_UPLOAD_URL, (fileName, uploadUrl, key) => ({
	payload: { fileName, uploadUrl, key }
}));

export function uploadFile(fileName, file, uploadUrl) {
	return (dispatch) => {
		// Fire Start Action
		dispatch(uploadStart({ fileName, file }));

		const config = {
			onUploadProgress: (progressEvent) => {
				// Fire upload progress event
				const progress = ((progressEvent.loaded / progressEvent.total) * 100);
				dispatch(uploadProgress({ fileName, uploadProgress: progress }));
			},
			headers: {
				'Content-Type': file.type
			}
		};

		return httpClient.put(uploadUrl, file, config)
		.then(() => dispatch(uploadSuccess({ fileName, file })))
		.catch((err) => dispatch(uploadFailure({ fileName, file, err })));
	};
}

export default fileUploadSlice.reducer;
